module.exports = __webpack_public_path__ + "img/anonymous-user.c69a8f63.png";